import {
  Box,
  Button,
  CircularProgress,
  FormLabel,
  Grid,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Routes } from "../../../constant/api_url";
import { insertProduct, updateProduct } from "src/api/commonapi";
import { notification } from "src/utils/messages";
import { IsNotValue } from "src/constant/variable";
import Select from "react-select";

export default function ProductInsertUpdateModal({
  addEditModal,
  setAddEditModal,
  toggleAddEditModal,
  rowData,
  setRowData,
  modalType,
  handleGetProducts
}) {
  const [productData, setProductData] = useState({
    p_name: modalType === "Edit" ? rowData?.p_name : "",
    p_price: modalType === "Edit" ? rowData?.p_price : "",
    p_city_price: modalType === "Edit" ? rowData?.p_city_price : "",
    p_type: modalType === "Edit" ? rowData?.p_type : 0
  });

  const [loader, setLoader] = useState(false);
  const [file, setFile] = useState({});
  const [fileimage, setfileimage] = useState("");

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  const productTypeOptions = [
    { value: 2, label: "Welcome Kit" },
    { value: 1, label: "Pin" },
    { value: 0, label: "Other" }
  ];

  const resetFormData = () => {
    setProductData({
      p_name: "",
      p_type: "",
      p_price: "",
      p_city_price: ""
    });
    setfileimage("");
  };

  useEffect(() => {
    if (modalType === "Edit") {
      setProductData({
        p_name: rowData?.p_name,
        p_price: rowData?.p_price,
        p_city_price: rowData?.p_city_price,
        p_type: rowData?.p_type
      });
    } else {
      resetFormData();
    }
  }, [modalType, rowData]);

  const handleProductSubmit = async () => {
    let fdata = new FormData();
    fdata.append("p_name", productData?.p_name);
    fdata.append("p_price", productData?.p_price);
    fdata.append("p_city_price", productData?.p_city_price);
    fdata.append("p_image", file?.file);
    fdata.append("p_type", productData?.p_type || 0);
    if (
      productData.p_name != "" &&
      productData.p_price != "" &&
      productData.p_city_price != "" &&
      productData.p_type !== null
    ) {
      if (modalType === "Edit") {
        fdata.append("p_id", rowData?.p_id);
        setLoader(true);
        let resp = await updateProduct(fdata);
        if (resp.status != 0) {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
          resetFormData();
          toggleAddEditModal();
          handleGetProducts();
        } else {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
        }
        setfileimage();

        setLoader(false);
      } else {
        setLoader(true);
        let resp = await insertProduct(fdata);
        if (resp.status != 0) {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
          resetFormData();
          toggleAddEditModal();
          handleGetProducts();
        } else {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
        }
        setfileimage("");
        setLoader(false);
      }
    } else {
      let notify = notification({
        type: "error",
        message: "Please Fill All Fields data"
      });
      notify();
    }
  };

  return (
    <Modal
      open={addEditModal}
      onClose={() => toggleAddEditModal()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          style={{ marginBottom: "5px", textAlign: "center" }}
        >
          {modalType} Product
        </Typography>
        <hr />
        <Stack style={{ marginBottom: "15px" }}>
          <Grid container spacing={1}>
            <Grid item sm={12} xs={12} md={6} lg={6}>
              <TextField
                style={{ marginTop: "22px" }}
                fullWidth
                required
                autoComplete="off"
                type="text"
                label="Product Name"
                size="small"
                name="p_name"
                placeholder="Enter Product Name"
                onChange={(e) => {
                  setProductData({
                    ...productData,
                    p_name: e.target.value
                  });
                }}
                value={productData?.p_name}
              />
            </Grid>
            <Grid item sm={12} xs={12} md={6} lg={6}>
              <label style={{ marginBottom: "10px" }}>Product Type</label>
              <Select
                value={productTypeOptions?.map((st) => {
                  if (st.value == productData.p_type) {
                    return { value: st.value, label: st.label };
                  }
                })}
                style={{ marginTop: "0px" }}
                name="p_type"
                onChange={(e) => {
                  setProductData({
                    ...productData,
                    p_type: e.value
                  });
                }}
                options={productTypeOptions}
              ></Select>
            </Grid>
            <Grid item sm={12} xs={12} md={6} lg={6}>
              <TextField
                style={{ marginTop: "15px" }}
                fullWidth
                required
                autoComplete="off"
                type="text"
                label="Price (Inclusive GST)"
                size="small"
                name="p_price"
                placeholder="Enter Price"
                onChange={(e) => {
                  setProductData({
                    ...productData,
                    p_price: e.target.value
                  });
                }}
                value={productData?.p_price}
              />
            </Grid>
            <Grid item sm={12} xs={12} md={6} lg={6}>
              <TextField
                style={{ marginTop: "15px" }}
                fullWidth
                autoComplete="off"
                size="small"
                required
                type="text"
                label="City Price (Inclusive GST)"
                name="p_city_price"
                placeholder="Enter City Price"
                onChange={(e) => {
                  setProductData({
                    ...productData,
                    p_city_price: e.target.value
                  });
                }}
                value={productData?.p_city_price}
              />
            </Grid>
            <Grid item sm={12} xs={12} md={6} lg={6}>
              <FormLabel id="demo-radio-buttons-group-label">Image</FormLabel> <br />
              {fileimage && (
                <img
                  src={fileimage}
                  alt="Preview"
                  width="100px"
                  height="80px"
                  style={{ margin: "5px" }}
                />
              )}
              {modalType === "Edit" && !IsNotValue.includes(rowData.p_image) ? (
                <img
                  src={`${Routes.API_HOSTNAME}products-image/${rowData.p_image}`}
                  alt="img"
                  width="100px"
                  height="80px"
                  style={{ margin: "5px" }}
                />
              ) : (
                ""
              )}
              <Button variant="contained" component="label" style={{ marginBottom: "20px" }}>
                Click To Upload File
                <input
                  id="file"
                  name="file"
                  type="file"
                  hidden
                  onChange={(event) => {
                    setFile({ file: event.currentTarget.files[0] });
                    setfileimage(URL.createObjectURL(event.currentTarget.files[0]));
                  }}
                  className="form-control"
                />
              </Button>
            </Grid>
            <Grid
              item
              sm={12}
              xs={12}
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => toggleAddEditModal()}
                style={{ marginTop: "15px", marginRight: "15px" }}
              >
                Close
              </Button>
              {/* <Button
                variant="contained"
                style={{ marginTop: "15px" }}
                onClick={() => !loader && handleProductSubmit()}
              >
                Submit
              </Button> */}
              <Button
                variant="contained"
                style={{ marginTop: "15px" }}
                color="primary"
                onClick={() => !loader && handleProductSubmit()}
                disabled={loader}
                startIcon={loader && <CircularProgress size={20} color="inherit" />}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Stack>
      </Box>
    </Modal>
  );
}
